import React, {ReactNode, useMemo, useRef, useState} from 'react'
import Text from '../../../../components/text/Text'
import WizImage from '../../../../components/image/WizImage'
import {useColor, useTag} from '../../../../utils/etc'
import useQueryPaytoSee from '../../../../hooks/api/leader/useQueryPaytoSeeLeader'
import {useImage} from '../../../../utils/image'
import Span from '../../../../components/text/Span'
import {useDisplayNumber} from '../../../../utils/number'
import WizTable from '../../../../components/table/TableFactory'
import {ComponentItem} from '../../../../components/useComponent'
import WizButton from '../../../../components/button/WizButton'
import DeletePTSLeaderModal from './DeletePayToSeeLeader'

interface IProps {
    className?: string
    active?: boolean
    priorityActive?: boolean
}

const NoneImage = () => (
    <div className={'w-[120px] h-[120px] leading-[120px] bg-line01 text-center text-white rounded-[10px]'}>
        이미지 없음
    </div>
)

const PaytoSeeLeadersTable: React.FC<IProps> = ({className}) => {
    // const {data, pageInfo, refetch} = useQueryEvent(currentPage, active)
    const {data, refetch} = useQueryPaytoSee()
    const {renderThumbnail} = useImage()
    const {getNumberColor} = useColor()
    const {renderPercent, floorBalance} = useDisplayNumber()
    const [target, setTarget] = useState('')

    const onClickDeletePtsLeader = (id: string) => {
        setTarget(id)
        deletePostModalRef?.current?.show()
    }

    const deletePostModalRef = useRef<any>()

    const headerTitles: string[] = ['user Info', 'Profit', 'Hold avg', '30D Trade Freq', 'WIN/LOSS', 'MDD', 'Actions']
    const headers: ComponentItem[] = headerTitles.map<ComponentItem>(el => ({
        component: Text,
        props: {
            children: el,
        },
    }))

    const rows = useMemo(() => {
        if (data === undefined || data?.length === 0) {
            return []
        }

        return data?.map<ReactNode[]>((item, i) => [
            <div className={'flex space-x-[10px] items-center md:justify-center'}>
                <WizImage
                    src={renderThumbnail(item?.thumbnail)}
                    className={'w-[36px] h-[36px] rounded-full md:w-[30px] md:h-[30px]'}
                />
                <Text className={'text-ti2 truncate'}>{item?.name}</Text>
            </div>,
            <div className={'sm:space-y-[5px]'}>
                <div className={'flex items-center'}>
                    <Span className={'hidden sm:inline'}>Profit : </Span>
                    <Text className={`text-ti2 ${getNumberColor(item?.profit_summary?.['30']?.profit)}`}>
                        {renderPercent(item?.profit_summary?.['30']?.profit)}
                    </Text>
                </div>
            </div>,

            <div className={'sm:space-y-[5px]'}>
                <Text className={`text-ti2 truncate`}>{item?.hold_avg}</Text>
            </div>,

            <div className={'space-y-[5px]'}>
                <Text className={`text-ti2 truncate`}>{item?.tf}</Text>
            </div>,

            <div className={'space-y-[5px]'}>
                <Text className={'text-body3 text-font03'}>Win</Text>
                <Text
                    className={`text-ti1 ${
                        item?.win / (item?.win + item?.loss) > 0.5 ? 'text-font_green' : 'text-font_red'
                    }`}>
                    {renderPercent((item?.win / (item?.win + item?.loss)) * 100, 100)}
                </Text>
            </div>,

            <div className={'space-y-[5px]'}>
                <Text className={`text-ti2 ${getNumberColor(item?.mdd)}`}>{renderPercent(item?.mdd)}</Text>
            </div>,
            <WizButton
                text={'Delete'}
                size={'small'}
                type={'red'}
                onClick={() => onClickDeletePtsLeader(item?.user_id)}
                className={''}
            />,
        ])
    }, [data])

    return (
        <div className={`${className}`}>
            <WizTable gridCols="7" className="w-full" headers={headers} items={rows} />
            <DeletePTSLeaderModal id={target} ref={deletePostModalRef} afterDelete={refetch} />
        </div>
    )
}

export default PaytoSeeLeadersTable
